export default __webpack_public_path__ + "static/media/trash.b4a1d362.svg";